import { combineReducers } from 'redux'

import faq from './faq/reducers'

const immigrateReducer = combineReducers({
  faq,
})

export default immigrateReducer
